/* KAELA — popup d'inscription « Tentez votre chance »
   Ouverture automatique apres un delai, une seule fois par visiteur pendant N jours.

   Quatre ecrans : le jeu, le mail, le numero, puis le cadeau. Le jeu est monte
   ici et non dans le Liquid, pour que la repartition des cartes soit tiree au
   sort a chaque ouverture. Sans JS le bloc du jeu reste masque et le formulaire
   est directement visible : l inscription marche quand meme.

   L envoi de l adresse RECHARGE la page — c est voulu, voir le bloc « L envoi
   de l adresse » plus bas. Le parcours reprend ensuite tout seul a l etape du
   numero grace a ?customer_posted=true. */
(function () {
  var popup = document.querySelector("[data-gift-popup]");
  if (!popup) return;

  var STORAGE_KEY = "kaela_gift_popup";
  var delay = parseInt(popup.getAttribute("data-delay"), 10) || 12000;
  var rememberDays = parseInt(popup.getAttribute("data-remember"), 10) || 7;
  var timer = null;
  var lastFocused = null;
  var pill = document.querySelector("[data-gift-pill]");
  var PILL_KEY = "kaela_gift_pill_refusee";
  /* Tant que l adresse n est pas donnee, fermer la popup ne doit pas faire
     disparaitre l offre : la pastille prend le relais. */
  var aDonneMail = false;

  /* Le mode navigation privee de Safari fait echouer localStorage : on ne veut pas
     que la popup disparaisse a cause de ca, on retombe simplement sur "jamais vue". */
  function readSeen() {
    try {
      return parseInt(window.localStorage.getItem(STORAGE_KEY), 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function markSeen() {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* stockage indisponible : tant pis, la popup se reaffichera */
    }
  }

  function recentlySeen() {
    var seen = readSeen();
    if (!seen) return false;
    return Date.now() - seen < rememberDays * 24 * 60 * 60 * 1000;
  }

  /* ?popup=1 force l ouverture immediate et ne memorise rien : sert a la relire
     autant de fois qu on veut sans vider le stockage du navigateur. */
  var forced = window.location.search.indexOf("popup=1") !== -1;

  /* La popup occupe tout l ecran : laisser la page defiler derriere donne un
     fond qui bouge sous un contenu fixe. On bloque, en compensant la largeur de
     la barre de defilement pour que la mise en page ne saute pas au moment ou
     elle disparait. */
  function bloquerDefilement(actif) {
    var doc = document.documentElement;
    if (actif) {
      var barre = window.innerWidth - doc.clientWidth;
      doc.style.overflow = "hidden";
      if (barre > 0) doc.style.paddingRight = barre + "px";
    } else {
      doc.style.overflow = "";
      doc.style.paddingRight = "";
    }
  }

  function open(remember) {
    popup.hidden = false;
    bloquerDefilement(true);
    lastFocused = document.activeElement;
    /* Deux images successives evitent que la transition parte avant l'affichage. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        popup.classList.add("is-open");
      });
    });
    var field = popup.querySelector(".gift-popup__input");
    if (field && window.matchMedia("(min-width: 601px)").matches) field.focus();
    if (remember !== false) markSeen();
  }

  function close() {
    popup.classList.remove("is-open");
    bloquerDefilement(false);
    window.setTimeout(function () {
      popup.hidden = true;
    }, 280);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    /* Partie sans avoir laisse son adresse : on garde une porte d entree. */
    if (!aDonneMail) montrerPastille();
  }

  /* ---------- Pastille de rattrapage ---------- */

  function pastilleRefusee() {
    try {
      return window.localStorage.getItem(PILL_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  /* Sur une fiche produit, la barre d achat est fixee en bas de l ecran : la
     pastille, posee a 18px du bord, tombait pile dedans. On la remonte juste
     au-dessus, en MESURANT la barre plutot qu en codant une hauteur en dur —
     elle change avec la largeur d ecran et avec le contenu du bouton.
     Sur une page sans barre, la valeur du CSS est conservee. */
  function eviterLaBarreDAchat() {
    if (!pill || pill.hidden) return;
    var barre = document.querySelector(".pm-sticky-atc");
    if (!barre) {
      pill.style.bottom = "";
      return;
    }
    var cs = window.getComputedStyle(barre);
    var r = barre.getBoundingClientRect();
    /* r.top < innerHeight : la barre n est pas encore entree dans l ecran.
       Elle glisse depuis le bas quand le bouton principal sort de la vue ; a
       ce moment-la son sommet est SOUS le bord de l ecran, et un calcul
       « innerHeight - top » donnerait une hauteur negative qui expedierait
       la pastille hors champ. Tant qu elle est dehors, on garde la valeur
       du CSS. */
    var visible =
      r.height > 0 &&
      cs.visibility !== "hidden" &&
      cs.opacity !== "0" &&
      cs.display !== "none" &&
      r.top < window.innerHeight;
    if (!visible) {
      pill.style.bottom = "";
      return;
    }
    var hauteurUtile = Math.round(window.innerHeight - r.top) + 12;
    pill.style.bottom = "calc(" + hauteurUtile + "px + env(safe-area-inset-bottom, 0px))";
  }

  /* La barre apparait et disparait AU DEFILEMENT : la position de la
     pastille doit donc etre recalculee a chaque defilement, pas seulement a
     son apparition. Passif, et tres bon marche : une seule mesure par
     evenement, et rien du tout tant que la pastille est cachee. */
  window.addEventListener("scroll", eviterLaBarreDAchat, { passive: true });
  window.addEventListener("resize", eviterLaBarreDAchat, { passive: true });

  function montrerPastille() {
    if (!pill || aDonneMail || pastilleRefusee()) return;
    pill.hidden = false;
    eviterLaBarreDAchat();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pill.classList.add("is-open");
      });
    });
  }

  function cacherPastille() {
    if (!pill) return;
    pill.classList.remove("is-open");
    window.setTimeout(function () {
      pill.hidden = true;
    }, 300);
  }

  if (pill) {
    pill.addEventListener("click", function (e) {
      /* La croix est DANS le bouton : sans ce test, la refuser rouvrirait la
         popup au lieu de la faire taire. */
      if (e.target.closest("[data-gift-pill-close]")) {
        e.stopPropagation();
        cacherPastille();
        try {
          window.localStorage.setItem(PILL_KEY, "1");
        } catch (err) {
          /* stockage indisponible : la pastille reviendra, tant pis */
        }
        return;
      }
      cacherPastille();
      /* remember=false : rouvrir depuis la pastille ne doit pas consommer
         l affichage unique, sinon fermer puis rouvrir grillerait l offre. */
      open(false);
    });

    pill.addEventListener("keydown", function (e) {
      if ((e.key === "Enter" || e.key === " ") && e.target.closest("[data-gift-pill-close]")) {
        e.preventDefault();
        e.stopPropagation();
        cacherPastille();
        try {
          window.localStorage.setItem(PILL_KEY, "1");
        } catch (err) {}
      }
    });
  }

  popup.addEventListener("click", function (e) {
    if (e.target.closest("[data-gift-close]")) close();
  });

  /* « J'en profite » : applique le code SANS changer de page (24/09/2026).
     /discount/<CODE> pose le cookie discount_code, que le checkout lit ensuite ;
     on l appelle en arriere-plan en le renvoyant vers /cart.js (reponse legere)
     au lieu de naviguer, puis on ferme. Si l appel echoue, on suit le lien
     normal, qui recharge la page en cours : le code doit arriver quoi qu il
     arrive. Verifie en production : cookie pose, page inchangee. */
  var cta = popup.querySelector("[data-gift-cta]");
  if (cta && window.fetch) {
    cta.addEventListener("click", function (e) {
      e.preventDefault();
      var lien = cta.getAttribute("href");
      var appel = lien.split("?")[0] + "?redirect=" + encodeURIComponent("/cart.js");
      cta.setAttribute("aria-disabled", "true");
      fetch(appel, { credentials: "same-origin" })
        .then(function (r) {
          if (!r.ok) throw new Error("HTTP " + r.status);
          close();
          /* Retirer ?customer_posted=true de l adresse : sinon un simple
             rafraichissement rouvrirait le popup sur le cadeau. */
          if (window.history && history.replaceState && window.URL) {
            var u = new URL(window.location.href);
            if (u.searchParams.has("customer_posted")) {
              u.searchParams.delete("customer_posted");
              history.replaceState(null, "", u.pathname + u.search + u.hash);
            }
          }
        })
        .catch(function () {
          window.location.href = lien;
        });
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !popup.hidden) close();
  });

  /* ---------- Les elements du parcours ---------- */
  var form = popup.querySelector("form");
  var game = popup.querySelector("[data-gift-game]");
  var cardsWrap = popup.querySelector("[data-gift-cards]");
  var fields = popup.querySelector("[data-gift-fields]");
  var reveal = popup.querySelector("[data-gift-reveal]");
  var phoneStep = popup.querySelector("[data-gift-phone]");
  var phoneInput = popup.querySelector("#gift-popup-phone");
  var phoneError = popup.querySelector("[data-gift-phone-error]");

  /* Cle PUBLIQUE Klaviyo (« company_id ») : elle est faite pour vivre dans la
     page, elle n autorise que l inscription. Ne JAMAIS mettre ici une cle
     privee pk_*. X7SHkX = liste « Liste pour la messagerie texte ». */
  var KLAVIYO_KEY = "UtDRNN";
  var KLAVIYO_LIST = "X7SHkX";
  var timerStarted = false;

  /* Le POST Shopify peut repartir en RECHARGEMENT COMPLET : fetch indisponible,
     touche Entree dans un champ du formulaire, extension qui coupe le JS. La
     page revient alors neuve, avec ?customer_posted=true — l adresse saisie est
     perdue et l etape telephone etait purement et simplement sautee. On met donc
     l adresse de cote AVANT l envoi, le temps de l onglet, pour pouvoir
     reprendre la ou on en etait. sessionStorage et pas localStorage : ca ne doit
     pas survivre a la fermeture de l onglet. */
  var MAIL_KEY = "kaela_gift_mail";
  var TEL_KEY = "kaela_gift_tel_fait";

  function memoriser(cle, valeur) {
    try {
      window.sessionStorage.setItem(cle, valeur);
    } catch (e) {
      /* navigation privee : on perdra l adresse au rechargement, sans plus */
    }
  }

  function relire(cle) {
    try {
      return window.sessionStorage.getItem(cle) || "";
    } catch (e) {
      return "";
    }
  }

  function startCountdown() {
    var timerEl = popup.querySelector("[data-gift-timer]");
    if (!timerEl || timerStarted) return;
    timerStarted = true;
    var minutes = parseInt(popup.getAttribute("data-countdown"), 10) || 15;
    var deadline = Date.now() + minutes * 60 * 1000;
    var tick = window.setInterval(function () {
      var left = Math.max(0, deadline - Date.now());
      var m = Math.floor(left / 60000);
      var sec = Math.floor((left % 60000) / 1000);
      timerEl.textContent = m + ":" + (sec < 10 ? "0" : "") + sec;
      if (left <= 0) {
        window.clearInterval(tick);
        var wrap = popup.querySelector("[data-gift-timer-wrap]");
        /* On ne dit pas "expire" : le code reste valable, ce serait faux. */
        if (wrap) wrap.textContent = "Gardez-le de côté, il vous attend.";
      }
    }, 1000);
  }

  /* Klaviyo exige le format E.164. Une Francaise tape « 06 12 34 56 78 » :
     sans conversion, le numero est refuse et l inscription perdue en silence. */
  function versE164(brut) {
    var n = String(brut || "").replace(/[^0-9+]/g, "");
    if (n.indexOf("+") === 0) return /^\+[1-9][0-9]{7,14}$/.test(n) ? n : "";
    if (n.indexOf("33") === 0 && n.length === 11) return "+" + n;
    if (n.indexOf("0") === 0 && n.length === 10) return "+33" + n.slice(1);
    return "";
  }

  function envoyerAKlaviyo(email, tel) {
    return fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + KLAVIYO_KEY, {
      method: "POST",
      headers: { "Content-Type": "application/vnd.api+json", revision: "2026-07-15" },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Popup cadeau - etape telephone",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email || undefined,
                  phone_number: tel,
                  subscriptions: { sms: { marketing: { consent: "SUBSCRIBED" } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: "list", id: KLAVIYO_LIST } } }
        }
      })
    });
  }

  function showPhone() {
    /* L adresse est deja enregistree quand on arrive ici : fermer maintenant ne
       doit plus faire reapparaitre la pastille de rattrapage. */
    aDonneMail = true;
    if (game) game.hidden = true;
    if (fields) fields.hidden = true;
    /* Au retour de Shopify, le Liquid a deja rendu le cadeau visible : sans ce
       masquage les deux ecrans s empileraient. */
    if (reveal) reveal.hidden = true;
    phoneStep.hidden = false;
    if (phoneInput) phoneInput.focus();
  }

  function showReveal() {
    aDonneMail = true;
    /* Le cadeau est montre : un rechargement ulterieur ne doit pas redemander
       le numero a quelqu un qui vient de le donner (ou de le refuser). */
    memoriser(TEL_KEY, "1");
    if (game) game.hidden = true;
    if (fields) fields.hidden = true;
    if (phoneStep) phoneStep.hidden = true;
    if (reveal) reveal.hidden = false;
    startCountdown();
  }

  if (reveal && !reveal.hidden) startCountdown();

  /* ---------- Le jeu : aligner 3 cartes ----------
     La face n est PAS decidee a l avance : elle est posee au moment du clic.
     Les trois premieres cartes cliquees sont gagnantes quelles qu elles
     soient, la quatrieme porte l intruse. La partie se gagne donc toujours en
     trois clics, sans jamais de clic « perdu » au milieu.

     C est invisible pour la visiteuse parce que la face avant est masquee par
     backface-visibility tant que la carte n a pas pivote : on peut la remplir
     juste avant de lancer la rotation. */

  function monterJeu() {
    var sachet = cardsWrap.getAttribute("data-gift-sachet") || "";
    var hint = popup.querySelector("[data-gift-hint]");
    var gagne = popup.querySelector("[data-gift-gagne]");
    var trouves = 0;
    var fini = false;

    cardsWrap.innerHTML = "";

    function remplirFace(face, gagnante) {
      face.textContent = "";
      if (gagnante && sachet) {
        var img = document.createElement("img");
        img.src = sachet;
        img.alt = "";
        img.width = 46;
        img.height = 46;
        img.style.width = "46px";
        img.style.height = "auto";
        face.appendChild(img);
      } else {
        face.textContent = gagnante ? "KAELA" : "★";
      }
    }

    for (var index = 0; index < 4; index++) {
      (function (i) {
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "gift-popup__carte";
        btn.setAttribute("aria-label", "Retourner la carte " + (i + 1));

        var inner = document.createElement("span");
        inner.className = "gift-popup__carte-inner";

        var dos = document.createElement("span");
        dos.className = "gift-popup__face gift-popup__face--dos";
        dos.textContent = "?";

        var avant = document.createElement("span");
        avant.className = "gift-popup__face gift-popup__face--avant";

        inner.appendChild(dos);
        inner.appendChild(avant);
        btn.appendChild(inner);

        btn.addEventListener("click", function () {
          if (fini || btn.disabled) return;

          remplirFace(avant, true);
          btn.classList.add("est-retournee");
          btn.disabled = true;
          trouves++;
          if (hint) hint.textContent = trouves + " sur 3.";
          if (trouves < 3) return;

          fini = true;
          if (hint) hint.textContent = "";
          /* On retourne aussi la carte restante : un plateau laisse a moitie
             cache donne l impression que la partie a ete coupee. C est elle
             qui porte l intruse, puisque les trois cliquees etaient gagnantes. */
          Array.prototype.forEach.call(cardsWrap.children, function (c) {
            if (!c.classList.contains("est-retournee")) {
              remplirFace(c.querySelector(".gift-popup__face--avant"), false);
              c.classList.add("est-retournee");
            }
            c.disabled = true;
          });
          window.setTimeout(function () {
            if (game) game.hidden = true;
            /* La partie est finie : « Tentez votre chance » n a plus de sens.
               C est l annonce du gain qui devient le titre, et elle le reste
               sur les ecrans suivants. Pilote en CSS par cette seule classe,
               pour qu il n y ait qu un endroit a changer. */
            popup.classList.add("gift-popup--gagne");
            if (gagne) gagne.hidden = false;
            if (fields) fields.hidden = false;
            var champ = popup.querySelector(".gift-popup__input");
            if (champ && window.matchMedia("(min-width: 601px)").matches) champ.focus();
          }, 900);
        });

        cardsWrap.appendChild(btn);
      })(index);
    }
  }

  /* Le jeu ne s affiche que si le formulaire n a pas deja ete envoye : au
     retour de Shopify (customer_posted=true) c est le cadeau qu on montre. */
  if (game && cardsWrap && fields && reveal && reveal.hidden) {
    game.hidden = false;
    fields.hidden = true;
    monterJeu();
  }

  /* ---------- L envoi de l adresse ----------
     On laisse le formulaire partir NORMALEMENT, avec le rechargement de page
     que cela implique.

     L envoi en arriere-plan qui etait fait ici marchait mieux a l ecran mais
     perdait des inscriptions : Shopify a active sa protection anti-robot sur
     les formulaires client (window.Shopify.captcha), et un POST envoye par
     fetch ne peut pas produire le jeton qu elle reclame. Le serveur repondait
     alors « 400 Missing CAPTCHA token » — que fetch considere comme une
     reponse reussie, donc le popup enchainait sur l ecran suivant et personne,
     ni la cliente ni nous, ne savait que l adresse etait perdue. Mesure du
     17/09/2026 sur la production.

     Un rechargement coute moins cher qu une inscription perdue. C est le retour
     de Shopify (?customer_posted=true, plus bas) qui reprend le parcours a
     l etape du numero. */
  if (form) {
    form.addEventListener("submit", function (e) {
      /* L etape du numero est DANS le formulaire Shopify : appuyer sur Entree
         dans le champ du telephone y declencherait une soumission implicite,
         donc un rechargement pour rien. On la traite comme un clic sur le
         bouton d envoi du numero. */
      if (phoneStep && !phoneStep.hidden) {
        e.preventDefault();
        var boutonTel = popup.querySelector("[data-gift-phone-submit]");
        if (boutonTel) boutonTel.click();
        return;
      }

      /* La page va recharger : sans cette mise de cote, l adresse serait perdue
         au retour et Klaviyo creerait un profil « telephone seul » au lieu
         d enrichir celui qui vient d etre cree. */
      var champMail = popup.querySelector("#gift-popup-email");
      if (champMail && champMail.value) memoriser(MAIL_KEY, champMail.value);

      /* Le rechargement n est pas instantane : sans retour visible, le clic
         parait rate et on repart pour un double envoi. */
      var btn = fields ? fields.querySelector(".gift-popup__button") : null;
      if (!btn) return;
      var libelleMail = btn.textContent;
      btn.disabled = true;
      btn.textContent = "Un instant…";

      /* Filet : la protection anti-robot de Shopify intercepte l envoi pour y
         glisser son jeton, et quand elle n y arrive pas elle l avale sans rien
         dire — ni requete, ni rechargement, ni message. Mesure du 17/09/2026.
         Sans ce filet la cliente reste devant un bouton fige pour toujours. Si
         la page est toujours la au bout de 6 s, on lui rend son bouton. */
      window.setTimeout(function () {
        btn.disabled = false;
        btn.textContent = libelleMail;
      }, 6000);
    });
  }

  /* ---------- Ecran 2 : le numero ----------
     Regle de conduite : le code promis est TOUJOURS montre a la fin, meme si
     Klaviyo tombe. La cliente a rempli sa part, on ne la punit pas d une
     panne de notre cote. L echec est avale, pas repercute. */
  if (phoneStep) {
    var phoneBtn = popup.querySelector("[data-gift-phone-submit]");
    var phoneSkip = popup.querySelector("[data-gift-phone-skip]");

    if (phoneSkip) {
      phoneSkip.addEventListener("click", function () { showReveal(); });
    }

    /* Ceinture et bretelles avec le garde-fou pose sur le formulaire : on
       n attend meme pas que la soumission implicite parte. */
    if (phoneInput) {
      phoneInput.addEventListener("keydown", function (e) {
        if (e.key !== "Enter") return;
        e.preventDefault();
        if (phoneBtn) phoneBtn.click();
      });
    }

    if (phoneBtn) {
      phoneBtn.addEventListener("click", function () {
        var tel = versE164(phoneInput ? phoneInput.value : "");
        if (phoneError) phoneError.hidden = true;

        if (!tel) {
          if (phoneError) {
            phoneError.textContent = "Numéro non reconnu. Exemple : 06 12 34 56 78.";
            phoneError.hidden = false;
          }
          return;
        }
        var libelle = phoneBtn.textContent;
        phoneBtn.disabled = true;
        phoneBtn.textContent = "Un instant…";

        var mail = popup.querySelector("#gift-popup-email");
        envoyerAKlaviyo(mail ? mail.value : "", tel)
          .then(function () { showReveal(); })
          .catch(function () { showReveal(); });

        /* Filet : si le reseau reste muet, on ne laisse pas la cliente devant
           un bouton fige. Au bout de 4 s le code s affiche quoi qu il arrive. */
        window.setTimeout(function () {
          if (phoneBtn.disabled) {
            phoneBtn.disabled = false;
            phoneBtn.textContent = libelle;
            showReveal();
          }
        }, 4000);
      });
    }
  }

  /* ---------- Quand ouvrir ----------
     Volontairement en dernier : ces 'return' sortent de la fonction, donc tout
     ce qui est place apres ne s'executerait jamais. C'est ce qui empechait
     l'interception du formulaire quand on arrivait avec ?popup=1. */

  /* ?popup=1 sert a REJOUER le parcours. Le marqueur « numero deja donne » vit
     le temps de l onglet : sans ce nettoyage, le deuxieme essai saute l etape
     du telephone et on croit qu elle a disparu. Jamais au retour de Shopify,
     ou ce meme marqueur est justement ce qui evite de redemander un numero a
     quelqu un qui vient de le laisser. */
  if (forced && window.location.search.indexOf("customer_posted=true") === -1) {
    memoriser(TEL_KEY, "");
  }

/* Retour de Shopify apres inscription : la redirection ajoute customer_posted=true.
     On rouvre pour montrer la confirmation plutot que de la laisser invisible. */
  if (window.location.search.indexOf("customer_posted=true") !== -1) {
    open();
    /* La partie est forcement gagnee pour en arriver la, mais la classe posee a
       la fin du jeu n a pas survecu au rechargement : le titre serait redevenu
       « Tentez votre chance » au-dessus du cadeau. */
    popup.classList.add("gift-popup--gagne");
    /* Le Liquid a rendu le cadeau directement visible : sur ce chemin l etape
       du numero etait sautee et le telephone jamais demande. On la remet, avec
       l adresse mise de cote juste avant l envoi — sans elle, Klaviyo creerait
       un profil « telephone seul » au lieu d enrichir celui de l e-mail. */
    if (phoneStep && !relire(TEL_KEY)) {
      var mailMemorise = relire(MAIL_KEY);
      var champMailRetour = popup.querySelector("#gift-popup-email");
      if (champMailRetour && mailMemorise) champMailRetour.value = mailMemorise;
      showPhone();
    } else {
      /* Sans ecran du numero (retire du Liquid le 24/09/2026), c est le cadeau
         qu on montre : showReveal marque aussi l adresse comme donnee, sinon la
         pastille « Offre mystere » reapparaissait a la fermeture. */
      showReveal();
    }
    return;
  }

  if (forced) {
    open(false);
    return;
  }

  if (recentlySeen()) return;

  timer = window.setTimeout(function () { open(); }, delay);

  /* ---------- Filet de securite : l intention de sortie ----------
     Si la personne s apprete a quitter avant la fin du delai, on montre la
     popup tout de suite plutot que de la rater. Le signal n est pas le meme
     selon l appareil, d ou deux detecteurs. */

  function ouvrirAvantDePartir(retirer) {
    if (recentlySeen() || !popup.hidden) return;
    window.clearTimeout(timer);
    retirer();
    open();
  }

  /* Ordinateur : le curseur sort par le HAUT de la fenetre, c est le geste qui
     vise la barre d adresse ou l onglet. clientY > 0 ecarte les sorties par les
     cotes et le bas, relatedTarget ecarte les simples passages d un element a
     un autre a l interieur de la page. */
  function surSortieCurseur(e) {
    if (e.clientY > 0 || e.relatedTarget) return;
    ouvrirAvantDePartir(function () {
      document.removeEventListener("mouseout", surSortieCurseur);
    });
  }

  /* Telephone : il n y a pas de curseur, donc pas de mouseout — l equivalent
     est la REMONTEE BRUSQUE vers le haut de la page, le geste de qui va
     chercher le bouton retour ou la barre d adresse. On exige les trois a la
     fois pour ne pas se declencher sur un simple defilement de lecture :
       - etre revenu pres du haut de la page,
       - monter vite (plus de 900 px par seconde),
       - etre deja descendu un minimum auparavant, sinon la popup s ouvrirait
         sur un micro-geste des les premieres secondes.
     Le listener est passif : il ne bloque jamais le defilement. */
  var yPrecedent = window.pageYOffset || 0;
  var tPrecedent = Date.now();
  var profondeurAtteinte = yPrecedent;

  function surDefilement() {
    var y = window.pageYOffset || 0;
    var t = Date.now();
    var dt = t - tPrecedent;
    if (y > profondeurAtteinte) profondeurAtteinte = y;
    if (dt > 0) {
      var vitesseVersLeHaut = ((yPrecedent - y) / dt) * 1000;
      if (y < 260 && vitesseVersLeHaut > 900 && profondeurAtteinte > 600) {
        ouvrirAvantDePartir(function () {
          window.removeEventListener("scroll", surDefilement);
        });
      }
    }
    yPrecedent = y;
    tPrecedent = t;
  }

  /* (hover: none) et (pointer: coarse) reunis = un ecran tactile sans souris.
     Tester l un ou l autre seul attrape des cas hybrides (portable tactile,
     stylet) ou le curseur existe bel et bien. */
  var surTactile =
    window.matchMedia &&
    window.matchMedia("(hover: none) and (pointer: coarse)").matches;

  if (surTactile) {
    window.addEventListener("scroll", surDefilement, { passive: true });
  } else {
    document.addEventListener("mouseout", surSortieCurseur);
  }
})();
